import SignaturesStepper from "@/components/Signatures/SignaturesDetails/SignaturesStepper.vue";
import EnvelopeBasicsTab from "@/components/Signatures/SignaturesDetails/Tabs/EnvelopeBasics/EnvelopeBasics.vue";
import DocumentsTabs from "@/components/Signatures/SignaturesDetails/Tabs/Documents/Documents.vue";
import SignersTab from "@/components/Signatures/SignaturesDetails/Tabs/Signers/Signers.vue";
import NotificationsTab from "@/components/Signatures/SignaturesDetails/Tabs/Notifications/Notifications.vue";
import EnvelopeService from "@/services/server/EnvelopeService";
import Utils from "@/scripts/Utils";
import {showErrorSnackBar} from "@/utils/SnackBartHelper";
import DocumentsService from "@/services/server/DocumentsService";
import SignersService from "@/services/server/SignersService";

export default {
    name: "SignaturesDetails",
    data: () => ({
        signatureFlowFirebase: {
            id_documents: [],
            id_signers: [],
        },
        isLoadingData: false,
        envelopeDataClickSign: {
            attributes: {
                status: ""
            }
        },
        documentsDataClickSign: [],
        signersDataClickSign: [],
        historicNameMapper: {},
        events: [],
        eventsMapping: [
            {text: "add_signer", value: "Novo Signatário"},
            {text: "cancel", value: "Documento Cancelado"},
            {text: "remove_signer", value: "Signatário Removido"},
            {text: "upload", value: "Documento Adicionado"},
            {text: "update", value: "Atualização do Envelope"},
            {text: "document_closed", value: "Atualização do Envelope"},
            {text: "auto_close", value: "Documento Finalizado Automáticamente"},
            {text: "sign", value: "Documento Assinado"},

        ],
        steps: [
            {
                id: 'envelope_basics',
                name: 'Dados Gerais',
                step: '1',
                editable: true,
                complete: false,
                rules: [() => true]
            },
            {
                id: 'documents',
                name: 'Documentos Anexados',
                step: '2',
                editable: true,
                complete: false,
                rules: [() => true]
            },
            {
                id: 'signers',
                name: 'Signatários',
                step: '3',
                editable: false,
                complete: false,
                rules: [() => true]
            },
            {
                id: 'notifications',
                name: 'Notificações',
                step: '4',
                editable: false,
                complete: false,
                rules: [() => true]
            }
        ],
        visibleTabs: {
            envelope_basics: true,
            documents: false,
            signers: false,
            notifications: false,
        }
    }),
    components: {
        NotificationsTab,
        SignaturesStepper,
        EnvelopeBasicsTab,
        DocumentsTabs,
        SignersTab,
    },
    computed: {
        determinateSteps() {
            return this.steps.map(step => {
                if (step.id === 'signers') {
                    step.editable = this.signatureFlowFirebase.id_documents.length > 0 || this.signatureFlowFirebase.id_signers.length > 0;
                } else if (this.envelopeDataClickSign.attributes.status !== 'canceled' &&
                    ['draft', 'running'].includes(this.envelopeDataClickSign.attributes.status) && step.id === 'notifications') {

                    step.editable = this.signatureFlowFirebase.id_signers.length > 0;
                }
                return step;
            });
        }
    },
    methods: {
        async getEventsFromEnvelopeFormatted(){
            const response = await EnvelopeService.getEventsFromEnvelope(this.signatureFlowFirebase.id_envelope);

            for (const event of response.data.data.data) {
                const eventType = event.attributes.name;

                let mappedName = this.eventsMapping.find(mapping =>
                    mapping.text === eventType ||
                    (eventType.startsWith('update') && mapping.text === eventType.split('_')[0])
                )?.value || eventType;

                this.events.push({
                    id: event.id,
                    name: mappedName,
                    actionDate: new Date(event.attributes.created).getTime()
                });
            }
        },
        nextTab(tabStep) {
            const index = this.steps.findIndex(({ step }) => step === tabStep)

            if (index < 0) throw new Error(`Não foi encontrado a aba: ${tabStep}`)

            Object.keys(this.visibleTabs).forEach(
                (key) => {
                    if (key === this.steps[index].id) {
                        this.visibleTabs[key] = true
                    } else {
                        this.visibleTabs[key] = false
                    }
                }
            )
        },
        formatDate(date) {
            return Utils.formatDateDayJs(date, 'DD/MM/YYYY [às] HH:mm');
        },
        async handleTabActivation(tab) {
            const tabNames = {
                documents: {
                    handler: this.getDocumentsData,
                    dataDestiny: this.documentsDataClickSign,
                },
                signers: {
                    handler: this.getSignersData,
                    dataDestiny: this.signersDataClickSign
                },
                notifications: {
                    handler: this.getSignersData,
                    dataDestiny: this.signersDataClickSign
                }
            };

            if (tabNames[tab] && !tabNames[tab].dataDestiny.length) {
                await tabNames[tab].handler();
            }
        },
        async updateSignatureFlowFirebase(newValue) {
            this.signatureFlowFirebase = newValue;
        },

        async getDocumentsData() {
            try {
                this.isLoadingData = true;

                const result = await DocumentsService.getAllDocuments(this.signatureFlowFirebase.id_envelope);

                for (const doc of result.data.data.data) {
                    this.documentsDataClickSign.push(doc)
                }

                this.isLoadingData = false;
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoadingData = false;
            }
        },
        async getSignersData() {
            try {
                this.isLoadingData = true;

                const result = await SignersService.getAllSigners(this.signatureFlowFirebase.id_envelope);

                for (const doc of result.data.data.data) {
                    this.signersDataClickSign.push(doc)
                }

                this.isLoadingData = false;
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoadingData = false;
            }
        },
        async handleSendingNotification() {
        },
        async getEnvelopesData() {
            try {
                this.isLoadingData = true;
                const resultFirebase = await EnvelopeService.getEnvelopeByIdFirebase(this.$route.params.id);
                this.signatureFlowFirebase = resultFirebase.data.data;

                const resultClickSign = await EnvelopeService.getEnvelopeByIdClickSign(this.signatureFlowFirebase.id_envelope);
                this.envelopeDataClickSign = resultClickSign.data.data;

                this.envelopeDataClickSign.attributes.created = this.formatDate(this.envelopeDataClickSign?.attributes.created)
                this.envelopeDataClickSign.attributes.modified = this.formatDate(this.envelopeDataClickSign?.attributes.modified)
                this.envelopeDataClickSign.attributes.deadline_at = this.formatDate(this.envelopeDataClickSign?.attributes.deadline_at)
                this.isLoadingData = false;
            } catch (e) {
                showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte!")
                console.error("Error: ", e);
            } finally {
                this.isLoadingData = false;
            }
        },
    },
    watch: {
        visibleTabs: {
            deep: true,
            handler(newValue) {
                Object.keys(newValue).forEach(tab => {
                    if (newValue[tab]) {
                        this.handleTabActivation(tab);
                    }
                });
            },
        }
    },
    async created() {
        await this.getEnvelopesData();
        await this.getEventsFromEnvelopeFormatted();
    }
}